require('./accountLastMovementsContent.scss');

// @vendors
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const React = require('react');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const AccountLastMovementsContentFilters = require('components/accounts/accountLastMovements/accountLastMovementsContent/accountLastMovementsContentFilters/accountLastMovementsContentFilters');
const AccountLastMovementsHeader = require('components/accounts/accountLastMovements/accountLastMovementsHeader/accountLastMovementsHeader');
const AccountLastMovementsTable = require('components/accounts/accountLastMovements/accountLastMovementsTable/accountLastMovementsTable');
const Sca = require('components/sca/sca');
const ScaDownloadMovements = require('components/sca/scaDownloadMovements');
const DownloadFileModal = require('components/commons/downloadFileModal/downloadFileModal');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const ProspectPrompt = require('components/prospectPrompt/prospectPrompt');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname');
const { recordLink, recordLinkV2 } = require('utilities/tagging');

// @constants
const TO_MUCH_ROWS_ERROR_MESSAGE = 'SELECCION MUY COSTOSA, ESPECIFIQUELA MAS';
const PAGINATION = 'PRIMERA';
const { VIEWER } = require('constants/contactCenter/pdfViewer');
const { CHECK_TYPES_FILE } = require('constants/fileRequirements');
const { MORE_MOVEMENTS_ACTION_EVENT, MORE_MOVEMENTS_EVENT_TAG } = require('constants/tagging');
const { LAVANDA } = require('constants/flagBasedFeatures');
class AccountLastMovementsContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            disclaimerClosed: false,
            disclaimerPrompt: true,
            downloadModalOpen: false,
        };

        this.buildDownloadButton = this.buildDownloadButton.bind(this);
        this.buildEmptyState = this.buildEmptyState.bind(this);
        this.buildNextPageButton = this.buildNextPageButton.bind(this);
        this.buildSca = this.buildSca.bind(this);
        this.downloadTransactionAsPDF = this.downloadTransactionAsPDF.bind(this);
        this.downloadTransactionAsXLS = this.downloadTransactionAsXLS.bind(this);
        this.handleCloseProspectPrompt = this.handleCloseProspectPrompt.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handleOpenPDFViewer = this.handleOpenPDFViewer.bind(this);
        this.handlePostRequest = this.handlePostRequest.bind(this);
        this.handleClickMoreMovements = this.handleClickMoreMovements.bind(this);
        this.handleToggleDownloadModal = this.handleToggleDownloadModal.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        this.sca = React.createRef();
    }

    buildDownloadButton() {
        const { immAccountTransactionsDownload } = this.props;
        const loading = immAccountTransactionsDownload.get('inProgress');
        const handleClick = __CONTACT_CENTER__ ? this.handleOpenPDFViewer : this.handleToggleDownloadModal;
        const iconClassName = conditionalClassName("icon-descargar", "icon-mostrar icon-modifier-regular", "icon");
        const downloadButton = (
            <div className="account-last-movements-content__download-button-container">
                <OKButton
                    id="btnDownloadAccountTransactions"
                    loading={loading}
                    onClick={handleClick}
                    modifier="task"
                    loaderSize="small"
                >
                    <i className={iconClassName} />
                </OKButton>
            </div>
        );
        const contentTooltip = __CONTACT_CENTER__ ? "accountMovements-previewIcon" : "accountMovements-downloadIcon";

        return (
            <OKTooltip
                content={contentTooltip}
                offset={[0, -15]}
                target={downloadButton}
                type="descriptive"
            />
        );
    }

    buildEmptyState(immFilter, immTransactions) {
        if (!immTransactions.get('scaRequiredAccountModal')) {
            const isAnyActiveFilter = ['amount', 'date', 'movementType', 'concept'].some(attr => !!immFilter.getIn([attr, 'isActive']));
            const primaryText = formatText(`accountMovements-emptyStateText${!isAnyActiveFilter && 'No' || ''}Filter`);
            return <EmptyState primaryText={primaryText} iconType="search-banking"/>; 
        }
        return this.buildSca();
    }

    buildPromptBoxContent(error) {
        const { isInactiveAccount } = this.props;
        const { disclaimerClosed, disclaimerPrompt } = this.state;
        if (isInactiveAccount && !error) {
            const inactiveTitle = <FormattedText value="myMoneyTransactions-inactiveAccountPromptTitle" />;
            const inactiveMessage = <FormattedText value="myMoneyTransactions-inactiveAccountPromptMessage" />;
            return (
                <div className="account-last-movements-content__prompt-box">
                    <ProspectPrompt
                        disclaimerClosed={disclaimerClosed}
                        disclaimerPrompt={disclaimerPrompt}
                        onCloseButtonClick={this.handleCloseProspectPrompt}
                        isInactiveAccount={isInactiveAccount}
                        inactiveTitle={inactiveTitle}
                        inactiveMessage={inactiveMessage}
                    />
                </div>
            );
        }
        return null;
    }

    buildErrorState(error) {
        const { onHandleRetry } = this.props;
        let retryButton;
        let primaryText;
        let iconType;
        if (error.get('description') === TO_MUCH_ROWS_ERROR_MESSAGE) {
            primaryText = formatText('accountMovements-emptyStateTextSoMuchRows');
            iconType = "search-banking";
        } else {
            primaryText = formatText('myMoneyTransactions-lostConnectionFirstLine');
            iconType="nointernet-banking"
            retryButton = (
                <OKButton id="btn_accountLastMovements_retry" onClick={onHandleRetry}>
                    <FormattedText value="myMoneyTransactions-retry" />
                </OKButton>
            );
        }
        return <EmptyState button={retryButton} primaryText={primaryText} iconType={iconType}/>;
    }

    buildTableContentState(immTransactions, immFilter, flagBasedFeatures, defaultLanguage) {
        const { immAccountTransactionsDownload } = this.props;
        return (
            <React.Fragment>
                <AccountLastMovementsTable
                    defaultLanguage={defaultLanguage}
                    immTransactions={immTransactions}
                    immFilter={immFilter}
                    flagBasedFeatures={flagBasedFeatures} 
                />
                {immAccountTransactionsDownload.get('scaRequiredToDownload')? this.buildScaDownloadTransactions(): this.buildSca()}
            </React.Fragment>
        )
    }

    buildSca() {
        const { flagBasedFeatures, immProfile, validateAndExecuteSagas, immSignaturePatternVirtualOffices, immTransactions } = this.props;
        return (
            <Sca
                ref={this.sca}
                flagBasedFeatures={flagBasedFeatures}
                onHandlePostRequest={this.handlePostRequest}
                immProfile={immProfile}
                immSignaturePatternVirtualOffices={immSignaturePatternVirtualOffices}
                immTransactions={immTransactions}
                onHandleNextPage={this.handleNextPage}
                validateAndExecuteSagas={validateAndExecuteSagas}
                showPN="true"
            />
        )
    }

    buildScaDownloadTransactions() {
        const { immAccountTransactionsDownload, immTransactions, immProfile, validateAndExecuteSagas, resetScaForAccountTransactionsDownload } = this.props;

        return(
            <ScaDownloadMovements
                onHandlePostRequest={this.handlePostRequestForDowloadingMovements}
                resetScaForAccountTransactionsDownload={resetScaForAccountTransactionsDownload}
                immProfile={immProfile}
                immTransactions={immTransactions}
                scaRequiredForDownloadTransactions={immAccountTransactionsDownload.get('scaRequiredToDownload')}
                validateAndExecuteSagas={validateAndExecuteSagas}
            />
        )
    }

    buildNextPageButton() {
        const modifier = !__CONTACT_CENTER__ ? 'widget' : 'complementary';
        return (
            <div className="account-last-movements-content__more-movements">
                <OKLink modifier={modifier} onClick={this.handleClickMoreMovements}>
                    <FormattedText
                        value="myMoneyTransactions-moreMovements"
                        format={__CONTACT_CENTER__ ? "uppercase" : undefined}
                    />
                </OKLink>
            </div>
        );
    }

    downloadTransactionAsPDF() {
        const { downloadAccountsTransactions, accountId } = this.props;
        downloadAccountsTransactions(accountId, CHECK_TYPES_FILE.PDF);
    }

    downloadTransactionAsXLS() {
        const { downloadAccountsTransactions, accountId } = this.props;
        downloadAccountsTransactions(accountId, CHECK_TYPES_FILE.XLS);
    }

    handleNextPage() {
        const { accountId, requestNextAccountTransactionsPage } = this.props;
        requestNextAccountTransactionsPage(accountId);    
        this.sca.current.newMovementsRequest();
    }

    handleToggleDownloadModal() {
        const { downloadModalOpen } = this.state;
        recordLinkV2({
            categoriaEvento: 'interaccion en movimientos',
            accionEvento: 'movimientos de cuenta',
            etiquetaEvento: 'descargar',
            action: 'download',
            format: 'button',
            component: 'movements',
            element: 'download',
        });
        this.setState({ downloadModalOpen: !downloadModalOpen });
    }

    handleOpenPDFViewer() {
        const { downloadAccountsTransactions, accountId } = this.props;
        downloadAccountsTransactions(accountId, 'PDF', VIEWER);
    }

    handleCloseProspectPrompt() {
        this.setState({
            disclaimerClosed: true,
            disclaimerPrompt: false
        });
    }

    handleClickMoreMovements() {
        const {
            accountId,
            flagBasedFeatures,
            immTransactions,
            toggleAccountMovementsScaModal,
        } = this.props;
        this.sca.current.newMovementsRequest();
        flagBasedFeatures.get(LAVANDA) && recordLink(window.utag_last_name, MORE_MOVEMENTS_ACTION_EVENT, MORE_MOVEMENTS_EVENT_TAG);
        if (immTransactions.get('scaRequiredAccountModal')) {
            toggleAccountMovementsScaModal(accountId);
        } else {
            this.handleNextPage();
        }
    }

    handlePostRequest = () => {
        const {
            accountId,
            requestAccountTransactions,
            requestNextAccountTransactionsPage,
            immTransactions
        } = this.props;
        const { nextPage } = immTransactions.toJS();

        nextPage.indexOf(PAGINATION) > -1 ? requestAccountTransactions(accountId) : requestNextAccountTransactionsPage(accountId, true);
    }

    handlePostRequestForDowloadingMovements = () => {
        const { resetScaForAccountTransactionsDownload, immAccountTransactionsDownload } = this.props;

        immAccountTransactionsDownload.get('fileFormat') === CHECK_TYPES_FILE.PDF? this.downloadTransactionAsPDF() : this.downloadTransactionAsXLS();
        resetScaForAccountTransactionsDownload();
    }

    render() {
        const {
            clearFilters,
            defaultLanguage,
            flagBasedFeatures,
            immFilter,
            immTransactions,
            onFilterClick,
            resetFilter
        } = this.props;

        const loading = !immTransactions || immTransactions.get('loading');
        const empty = immTransactions && immTransactions.get('byOrder').size === 0;
        const error = immTransactions && immTransactions.get('error');
        
        const promptBoxContent = this.buildPromptBoxContent(error);
        let nextPageButton;
        let tableContent;
        let nextPageLoadingSection;
        let downloadButton;

        if (loading) {
            tableContent = <LoadingSection />;
        } else if (error) {
            tableContent = this.buildErrorState(error);    
        } else if (empty) {
            tableContent = this.buildEmptyState(immFilter, immTransactions);
        } else {
            tableContent = this.buildTableContentState(immTransactions, immFilter, flagBasedFeatures, defaultLanguage);
            if (immTransactions.get('isFetchingNextPage')) {
                nextPageLoadingSection = <LoadingSection />;
            } else if (immTransactions.get('nextPage')) {
                nextPageButton = this.buildNextPageButton();
            }
            downloadButton = this.buildDownloadButton();
        }

        return (
            <div className="account-last-movements-content">
                {promptBoxContent}
                <AccountLastMovementsHeader
                    immFilter={immFilter}
                    onFilterClick={onFilterClick}
                    clearFilters={clearFilters}
                    downloadButton={downloadButton}
                />
                <AccountLastMovementsContentFilters
                    immFilter={immFilter}
                    immTransactions={immTransactions}
                    clearFilters={clearFilters}
                    resetFilter={resetFilter}
                />
                {tableContent}
                {nextPageLoadingSection}
                <div className="account-last-movements-content__actions row no-gutter">
                    <div className="col-xs-12">
                        {nextPageButton}
                    </div>
                </div>
                <DownloadFileModal
                    isOpen={this.state.downloadModalOpen}
                    onToggleDownloadModal={this.handleToggleDownloadModal}
                    title="accountsTransactionsDownload-title"
                    mainMessage="accountsTransactionsDownload-mainMessage"
                    firstOptionHandler={this.downloadTransactionAsPDF}
                    secondOptionHandler={this.downloadTransactionAsXLS}
                    firstOptionText="downloadFileModal-downloadAsPDF"
                    secondOptionText="downloadFileModal-downloadAsXLS"
                />
            </div>
        );
    }
}

AccountLastMovementsContent.propTypes = {
    accountId: PropTypes.string,
    clearFilters: PropTypes.func,
    defaultLanguage: PropTypes.string,
    downloadAccountsTransactions: PropTypes.func.isRequired,
    resetScaForAccountTransactionsDownload: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    immAccountTransactionsDownload: PropTypes.object,
    immFilter: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immSignaturePatternVirtualOffices: PropTypes.object.isRequired,
    immTransactions: PropTypes.object,
    isInactiveAccount: PropTypes.bool,
    onFilterClick: PropTypes.func,
    onHandleRetry: PropTypes.func.isRequired,
    requestAccountTransactions: PropTypes.func.isRequired,
    requestNextAccountTransactionsPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func,
    toggleAccountMovementsScaModal: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

module.exports = AccountLastMovementsContent;
